import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import request from "../../qnb/api/request";
export function getCountriesCode() { return _getCountriesCode.apply(this, arguments); }
function _getCountriesCode() { _getCountriesCode = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() { var resp; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            _context.next = 2;
            return request.post("/api/v1/online/online/getCountriesCodeList", { useSubmitTime: true });
        case 2:
            resp = _context.sent;
            return _context.abrupt("return", resp.data);
        case 4:
        case "end": return _context.stop();
    }
} }, _callee); })); return _getCountriesCode.apply(this, arguments); }
